import React, { useEffect, useState } from 'react';
import 'leaflet/dist/leaflet.css';
import './App.css';
import { useToast }      from './hooks/useToast';
import { useAuth }       from './hooks/useAuth';
import { useAssemblies } from './hooks/useAssemblies';
import { useAdminDashboard } from './hooks/useAdminDashboard';
import AuthPage          from './features/auth/AuthPage';
import Dashboard         from './features/assemblies/Dashboard';
import AdminDashboard    from './features/admin/AdminDashboard';

export default function App() {
  const { toast, notify }  = useToast();
  const auth               = useAuth(notify);
  const ctx                = useAssemblies(auth.token, notify);
  const adminCtx           = useAdminDashboard(auth.token, notify);
  const { loadAssemblies, loadOperationalMetrics, loadNewspaperData } = ctx;
  const { loadInitial }    = adminCtx;
  const [adminModule, setAdminModule] = useState('dashboard');

  useEffect(() => {
    if (!auth.user) return;
    if (auth.user.isAdmin) {
      if (adminModule === 'assemblies') {
        loadAssemblies();
        loadOperationalMetrics();
        loadNewspaperData();
        return;
      }
      loadInitial();
      return;
    }
    loadAssemblies();
    loadOperationalMetrics();
    loadNewspaperData();
  }, [
    auth.user,
    adminModule,
    loadAssemblies,
    loadOperationalMetrics,
    loadNewspaperData,
    loadInitial
  ]);

  if (!auth.token || !auth.user) {
    return <AuthPage toast={toast} auth={auth} />;
  }

  if (auth.user.isAdmin) {
    if (adminModule === 'assemblies') {
      return (
        <Dashboard
          toast={toast}
          auth={auth}
          ctx={ctx}
          initialView="calendar"
          onBackToAdmin={() => setAdminModule('dashboard')}
        />
      );
    }

    return (
      <AdminDashboard
        toast={toast}
        auth={auth}
        adminCtx={adminCtx}
        activeModule={adminModule}
        onNavigateModule={setAdminModule}
      />
    );
  }

  return <Dashboard toast={toast} auth={auth} ctx={ctx} />;
}
